import type * as filestack from "filestack-js";
import {
  ForbiddenFileExtensions,
  ForbiddenFileMimeTypes,
} from "@smartsuite/types";

export const acceptFileFn = async (
  file: filestack.PickerFileMetadata,
): Promise<string> => {
  // Cloud sources (OneDrive, Google Drive, ...) carry no originalFile, only picker metadata.
  const original = file.originalFile as File | undefined;
  const name = file.filename ?? original?.name ?? "";
  const mimeType = file.mimetype ?? original?.type ?? "";
  if (isForbiddenFile(name, mimeType)) {
    throw new Error(`File type not allowed: ${name}`);
  }
  return "ok";
};

const isForbiddenFile = (name: string, mimeType: string): boolean => {
  const ext = name.split(".").pop()?.toLowerCase() ?? "";
  return (
    ForbiddenFileExtensions.includes(ext) ||
    ForbiddenFileMimeTypes.includes(mimeType)
  );
};
